import styled from 'styled-components';

export const Wrapper = styled.section`
  @media screen and (min-width: 768px) {
    padding: 0 1rem;
  }
`;

export const Title = styled.h2`
  font-size: 1.2rem;
  font-weight: 600;
  padding: 0;
  margin: 1rem auto;
  text-align: center;
  @media screen and (min-width: 768px) {
    text-align: left;
  }
`;

export const ListTags = styled.div`
  line-height: 1.6;
  a:hover {
    color: var(--blue-1);
  }
`;
